module.exports = {"150626100":"嘎鲁图镇","150626101":"乌审召镇","150626102":"图克镇","150626103":"乌兰陶勒盖镇","150626104":"无定河镇","150626200":"苏力德苏木乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150626.json
// module id = 443
// module chunks = 0